<template>
  <div class="all" :class="{ 'error-body': bodyClass }">
    <img class="hack-share-img" :style="{ src: shareImgSrc }" />
    <div class="container">
      <div class="group" :style="{ display: groupStyle }">
        <div class="body">
          <div class="header">
            <div class="header-top">
              <i></i>
              <i></i>
            </div>
            <div class="header-info">
              <div class="header-avatar">
                <img :src="avatarSrc" />
              </div>
              <span>{{ nickname }}</span>
            </div>
            <i></i>
          </div>
          <div class="content">
            <div class="content-bg">
              <img src="../../assets/images/content-top.png" />
              <div class="content-bg-center"></div>
              <img src="../../assets/images/content-bottom.png" />
            </div>
            <div class="content-box">
              <div class="group-icon">
                <img :src="groupIcon" />
              </div>
              <div class="group-info">
                <span>{{ groupName }}</span>
                <div class="group-info-box">
                  <div
                    class="group-tag-info-box"
                    :style="{ display: infoBoxStyle }"
                  >
                    <div class="group-tag-info">
                      <img src="../../assets/images/group-blue.png" />
                      <span class="official-tag-text">{{ officialText }}</span>
                    </div>
                    <i></i>
                  </div>
                  <div
                    class="group-user-info-box"
                    :style="{ display: userInfoStyle }"
                  >
                    <div class="group-user-info">
                      <img src="../../assets/images/icon.png" />
                      <span class="member-num">{{ numberNum }}</span>
                    </div>
                    <i></i>
                  </div>
                  <div
                    class="group-id-info"
                    :data-clipboard-text="groupId"
                    ref="idInfo"
                  >
                    <span>ID：</span>
                    <span class="id-num">{{ groupId }}</span>
                    <img src="../../assets/images/copy.png" />
                  </div>
                </div>
              </div>
              <p class="group-introduction">{{ groupIntroduction }}</p>
              <div class="group-bottom">
                <button
                  :disabled="buttonDisable"
                  :class="{ visible: buttonClass }"
                  @click="buttonOnClick"
                >
                  {{ buttonText }}
                </button>
                <span
                  class="share-expiration-tips"
                  :class="{ visible: shareTipsClass }"
                  >{{ shareTipsContent }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="left-bg"></div>
        <div class="right-bg"></div>
        <div class="footer-bg"></div>
      </div>

      <div class="mask-box" :style="{ display: maskStyle }" @click="maskClick">
        <img src="../../assets/images/tips.png" />
      </div>
      <div class="error" :class="{ hide: errorClass }">
        <div class=""></div>
        <img src="../../assets/images/error.png" class="img" />
        <div class="msg" :v-html="msgContent">网络异常，请稍后重试</div>
        <div class="btn" @click="errorClick">
          <div class="btn-side"></div>
          <div class="btn-center">
            <div>探索更多房间</div>
          </div>
          <div class="btn-side"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClipboardJS from 'clipboard';
export default {
  data() {
    return {
      groupId: null,
      uid: null,
      shareToken: null,
      endTime: null,
      canShowGroupJoinCount: false,
      allowJoin: false,
      shareTokenIsValid: !this.shareToken,
      buttonDisable: false,
      buttonClass: '',
      buttonText: '',
      shareTipsClass: '',
      maskStyle: 'none',
      userInfoStyle: 'none',
      groupName: '',
      shareImgSrc: '',
      groupIcon: '',
      numberNum: '',
      infoBoxStyle: 'none',
      officialText: '',
      groupIntroduction: '',
      groupStyle: 'flex',
      errorClass: 'hide',
      bodyClass: '',
      msgContent: null,
      nickname: '',
      avatarSrc: '',
      shareTipsContent: '邀请链接将在0小时后失效',
    };
  },
  methods: {
    showToast(text) {
      if (window.KK_SDK.env.isApp) {
        window.KK_SDK.ui.showToast(text);
      } else {
        alert(text);
      }
    },
    checkAllowJoin() {
      if (this.allowJoin && this.shareTokenIsValid) {
        (this.buttonText = '加入房间'),
        (this.buttonDisable = false),
        (this.buttonClass = 'visible');
      } else {
        (this.buttonText = '邀请已过期'),
        (this.buttonDisable = true),
        (this.buttonClass = 'visible');
        if (this.shareToken && !this.shareTokenIsValid) {
          this.shareTipsClass = '';
        }
      }
    },
    buttonOnClick() {
      const { groupId, uid } = this;

      window.KK_SDK.report({
        operId: '1602000110201',
        ext1: window.KK_SDK.tools.uri.getChannel(),
        groupId,
        toUid: uid,
      });
      const scheme = 'kknk://flutter?page=home&action=open_group&gid='
        .concat(groupId, '&invite_uid=')
        .concat(uid, '&share_token=')
        .concat(this.shareToken);

      if (window.KK_SDK.env.isApp) {
        window.KK_SDK.ui.openView(scheme);
      } else {
        if (
          window.KK_SDK.env.android
          && (window.KK_SDK.env.mqq || window.KK_SDK.env.wx)
        ) {
          this.maskStyle = 'block';
        } else {
          window.KK_SDK.app.launch({
            scheme,
            autoInstall: false,
            directDownload: window.KK_SDK.env.android,
          });
        }
      }
    },
    maskClick() {
      this.maskStyle = 'none';
    },
    errorClick() {
      const scheme = 'kknk://flutter?page=discover';

      if (window.KK_SDK.env.isApp) {
        window.KK_SDK.ui.openView(scheme);
      } else {
        if (
          window.KK_SDK.env.android
          && (window.KK_SDK.env.mqq || window.KK_SDK.env.wx)
        ) {
          this.maskStyle = 'block';
        } else {
          window.KK_SDK.app.launch({
            scheme,
            autoInstall: false,
            directDownload: window.KK_SDK.env.android,
          });
        }
      }
    },
    getCommonConfig() {
      window.KK_SDK.http
        .request({
          method: 'GET',
          url: 'devtools-api/common-config',
          data: {
            category: 'app-flutter',
          },
        })
        .then((res) => {
          const commonSwitch = JSON.parse(res.data.common_switch);
          const isHiddenGroupMemberNum = commonSwitch.hidden_group_member_num;
          this.canShowGroupJoinCount =            typeof isHiddenGroupMemberNum !== 'undefined'
            ? !isHiddenGroupMemberNum
            : true;
        })
        .finally(() => {
          if (this.canShowGroupJoinCount) {
            this.userInfoStyle = 'block';
          }
        });
    },
    getUserInfo() {
      window.KK_SDK.http
        .request({
          url: 'knockknock.UserBaseSrv/GetUserInfoBase',
          data: {
            uid_list: [Number(this.uid)],
          },
        })
        .then((data) => {
          const info = data.user_info_map[this.uid];
          if (!info) {
            this.showToast('不存在该用户！');
            return;
          }
          this.nickname = info.nickname;
          this.avatarSrc = info.avatar;
        })
        .catch(() => {
          this.showToast('用户不存在，请检查链接参数！');
        });
    },
    getGroupInfo() {
      window.KK_SDK.http
        .request({
          url: 'knockknock.GroupBaseSrv/GetGroupInfo',
          data: {
            gid: Number(this.groupId),
            need_channel: false,
            need_user_list: false,
          },
        })
        .then((data) => {
          document.title = 'NOKNOK | '.concat(data.info.info.name);
          const tagType = data.info.info.tag_type;
          const tagName = data.info.info.tag_name;
          const { profile } = data.info.info;
          this.groupName = data.info.info.name;
          this.shareImgSrc = data.info.info.avatar;
          this.groupIcon = data.info.info.avatar;
          this.numberNum = ''.concat(
            data.info.member_num,
            '\u4F4D\u6210\u5458',
          );

          if (tagType === 1) {
            this.infoBoxStyle = 'flex';
            this.officialText = tagName;
          }

          if (profile) {
            this.groupIntroduction = '\u623F\u95F4\u7B80\u4ECB\uFF1A'.concat(profile);
          }

          if (!this.allowJoin) {
            this.allowJoin = data.info.allow_join;
          }

          this.checkAllowJoin();
        })
        .catch((result) => {
          this.groupStyle = 'none';
          (this.errorClass = ''), (this.bodyClass = 'error-body');

          if (result && result.data && result.data.msg) {
            this.msgContent = result.data.msg;
          }
          this.checkAllowJoin(); // showToast('房间不存在，请检查链接参数！');
        });
    },
    getShareValid() {
      window.KK_SDK.http
        .request({
          url: 'knockknock.GroupMinorSrv/CheckShareValid',
          data: {
            gid: Number(this.groupId),
            token: this.shareToken,
          },
        })
        .then((data) => {
          const time = Math.ceil(+new Date() / 1000);
          this.endTime = Number(this.endTime);

          if (data.ok && this.endTime) {
            const diffTime = this.endTime - time;

            if (diffTime > 0) {
              let diffTimeText = '';
              const hours = diffTime / (60 * 60);
              const minute = diffTime / 60;

              if (hours > 1) {
                diffTimeText = ''.concat(Math.round(hours), '\u5C0F\u65F6');
              } else if (minute > 1) {
                diffTimeText = ''.concat(Math.round(minute), '\u5206\u949F');
              } else {
                diffTimeText = ''.concat(diffTime, '\u79D2');
              }

              this.allowJoin = true;
              this.shareTokenIsValid = true;
              this.shareTipsContent =                '\u9080\u8BF7\u94FE\u63A5\u5C06\u5728'.concat(
                diffTimeText,
                '\u540E\u5931\u6548',
              );
              this.shareTipsClass = 'visible';
            }
          }

          this.checkAllowJoin();
        })
        .catch(this.checkAllowJoin);
    },
  },
  created() {
    const lowerPlatformBefore = navigator.platform?.toLowerCase() ?? '';
    const lowerPlatformNow = navigator.userAgentData?.platform?.toLowerCase() ?? '';
    const isWindows = lowerPlatformBefore.indexOf('win') > -1 || lowerPlatformNow.indexOf('windows') > -1;
    const isMac = lowerPlatformBefore.indexOf('mac') > -1 || lowerPlatformNow.indexOf('mac') > -1;

    if (isWindows || isMac) {
      this.showToast('当前为App房间邀请链接哦，请在移动端打开吧～');
    }
    this.groupId = (window.KK_SDK.tools.uri.query.gid || '').trim();
    this.uid = (window.KK_SDK.tools.uri.query.uid || '').trim();
    this.shareToken = (window.KK_SDK.tools.uri.query.token || '').trim();
    this.endTime = (window.KK_SDK.tools.uri.query.ets || '').trim();
    window.KK_SDK.report({
      operId: '1602000110101',
      ext1: window.KK_SDK.tools.uri.getChannel(),
      groupId: this.groupId,
      toUid: this.uid,
    });
    this.getCommonConfig();
    this.getUserInfo();
    this.getGroupInfo();
    if (this.shareToken) {
      this.getShareValid();
    }
  },
  mounted() {
    const clipboard = new ClipboardJS(this.$refs.idInfo);
    clipboard.on('success', () => {
      this.showToast('复制成功！');
    });
  },
};
</script>

<style lang="scss">
a,
body,
dd,
div,
dl,
dt,
em,
h1,
h2,
h3,
h4,
h5,
html,
i,
img,
input,
li,
p,
span,
ul {
  margin: 0;
  padding: 0;
}

a,
img,
input {
  border: none;
}

input {
  -webkit-appearance: none;
  appearance: none;
}

a {
  text-decoration: none;
}

li,
ul {
  list-style: none;
}

a,
img {
  -webkit-touch-callout: none;
}

input,
select,
button {
  border: none;
  background-color: transparent;
}

body {
  font: 14px/1.75 -apple-system, BlinkMacSystemFont, 'PingFang SC',
    'Helvetica Neue', STHeiti, 'Microsoft Yahei', Tahoma, Simsun, sans-serif;
  -webkit-tap-highlight-color: transparent;
  background: #b4ff3f;
}

html,
body,
#app {
  height: 100%;
  width: 100%;
}

.group {
  flex: 1;
  background: top center url('../../assets/images/bg.png') repeat-x;
  background-size: 45px 724px;
  overflow: auto;
}

a {
  text-decoration: none;
}

li,
ul {
  list-style: none;
}

a,
img {
  -webkit-touch-callout: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

* {
  margin: 0;
  padding: 0;
  outline: 0;
  outline-style: none;
  box-sizing: border-box;
  position: relative;
  -webkit-overflow-scrolling: touch;
}

a,
button,
div,
form,
iframe,
img,
input,
label,
ul,
li,
p,
span,
textarea {
  display: flex;
  flex-direction: column;
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

img[src=''],
img:not([src]) {
  opacity: 0;
}

.body {
  position: relative;
  z-index: 10;
}
.all {
  width: 100%;
  height: 100%;
}
.container {
  width: 100%;
  height: 100%;
}
.header {
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 9px;
}

.header .header-top {
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 9px;
}

.header .header-top i {
  height: 8px;
  background-size: 100% 100%;
}

.header .header-top i:first-child {
  width: 47px;
  background-image: url('../../assets/images/top-icon-1.png');
}

.header .header-top i + i {
  width: 48px;
  background-image: url('../../assets/images/top-icon-2.png');
}

.header .header-info {
  height: 24px;
  margin-top: 17.5px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.header .header-avatar {
  width: 16px;
  height: 16px;
  border-radius: 16px;
  background-color: #ffffff;
  border: 1px solid #000000;
  overflow: hidden;
}

.header span {
  margin-left: 6px;
  font-weight: bold;
  font-size: 15px;
  color: #ffffff;
  text-shadow: #000 1px 0 0, #000 0 1px 0, #000 -1px 0 0, #000 0 -1px 0;
}

.header > i {
  width: 207px;
  height: 41px;
  margin-top: 8.5px;
  background: url('../../assets/images/text-join.png');
  background-size: 100% 100%;
}

.content {
  margin: 70px 30px 0 30px;
  position: relative;
}

.content .content-bg {
  flex-direction: column;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.content .content-bg img {
  width: 100%;
  height: auto;
  object-fit: contain;
}

.content .content-bg-center {
  flex: 1;
  background: url('../../assets/images/content-center.png') repeat-y;
  background-size: 100% auto;
}

.content .content-box {
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 5;
}

.content .group-icon {
  width: 88px;
  height: 88px;
  margin-top: -40.5px;
  border-radius: 6px;
  background-color: #ffffff;
  overflow: hidden;
  box-shadow: 0px 10px 16px rgba(0, 0, 0, 0.08);
}

.content .group-info {
  justify-content: center;
  align-items: center;
  margin-top: 29px;
}

.content .group-info > span {
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: #2bde73;
}

.content .group-info .group-info-box {
  height: 19px;
  flex-direction: row;
  align-items: center;
  margin-top: 2px;
}
.content .group-info .group-tag-info-box {
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.content .group-info .group-tag-info-box > i {
  width: 1px;
  height: 14px;
  background: #333333;
  opacity: 0.2;
  margin: 0px 12px;
}
.content .group-info .group-tag-info {
  display: flex;
  flex-direction: row;
}
.content .group-info .group-tag-info img {
  width: 15px;
  height: 15px;
  margin-right: 4px;
  margin-top: 2px;
}
.content .group-info .group-tag-info .official-tag-text {
  color: #1EC3FF;
}

.content .group-info .group-user-info-box {
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.content .group-info .group-user-info-box > i {
  width: 1px;
  height: 14px;
  background: #333333;
  opacity: 0.2;
  margin: 0px 12px;
}

.content .group-info .group-user-info {
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.content .group-info .group-user-info img {
  width: 18px;
  height: 18px;
}

.content .group-info .group-info-box span {
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  color: #333333;
}

.content .group-info .group-user-info .member-num {
  margin-left: 1px;
}

.group-id-info {
  flex-direction: row;
  align-items: center;
}

.group-id-info img {
  width: 18px;
  height: 18px;
  margin-left: 1px;
}

.group-introduction {
  margin: 22px 20px 26.5px;
  font-weight: normal;
  font-size: 13px;
  line-height: 20px;
  text-align: center;
  color: #7a7a8d;
  word-break: break-all;
}

.content .content-box .group-bottom {
  display: flex;
  margin-top: 35px;
  margin-bottom: 55px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.content .content-box .group-bottom button {
  width: 165px;
  height: 40px;
  margin-bottom: 8px;
  justify-content: center;
  align-items: center;
  background: url('../../assets/images/button.png') no-repeat;
  background-size: 100% 100%;
  font-weight: 600;
  font-size: 16px;
  color: #000000;
  visibility: hidden;
}

.content .content-box .group-bottom button.visible {
  visibility: visible;
}

.content .content-box .group-bottom button:disabled {
  background: url('../../assets/images/button-disable.png') no-repeat;
  background-size: 100% 100%;
  color: #bcbdcc;
}

.content .content-box .share-expiration-tips {
  font-size: 11px;
  line-height: 1.5;
  color: #bcbdcc;
  visibility: hidden;
}

.content .content-box .share-expiration-tips.visible {
  visibility: visible;
}

.left-bg {
  width: 7px;
  height: 225px;
  background: url('../../assets/images/page-bg-left.png') no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 181.5px;
  left: 10px;
}

.right-bg {
  width: 7px;
  height: 207px;
  background: url('../../assets/images/page-bg-right.png') no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 373.5px;
  right: 9px;
}

.footer-bg {
  height: 139px;
  background: center center url('../../assets/images/page-bg-bottom.png')
    no-repeat;
  background-size: 375px 139px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
}

.mask-box {
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
}

.mask-box img {
  width: 266px;
  height: 95.5px;
  position: absolute;
  top: 20px;
  right: 20px;
}

.hack-share-img {
  width: 0;
  height: 0;
  opacity: 0;
}

.error-body {
  background: #ffffff;
}

.error {
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  justify-content: center;
}

.error .img {
  width: 195px;
  height: 188px;
}

.error .msg {
  padding: 17px;
  font-size: 16px;
  color: #7a7a8d;
}

.error .btn {
  height: 40px;
  width: 165px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.error .btn-side {
  height: 32px;
  width: 4px;
  background-color: #3fff88;
}

.error .btn-center {
  height: 40px;
  flex: 1;
  background-color: #3fff88;
  display: flex;
  align-items: center;
  justify-content: center;
}

.error .btn-center div {
  font-size: 16px;
  color: #333333;
}

.hide {
  display: none;
}
</style>
